import React from "react";

function SadFace() {
  return (
    <div className="d-flex justify-content-center">
      <span className="emoji text-dark">&#9785;</span>
    </div>
  );
}

export default SadFace;
